import * as Yup from "yup";

export default Yup.object().shape({
  firstName: Yup.string(),
  lastName: Yup.string(),
});
